module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-viewer-right-a1e0a87710485612c7e5770f460b1263.png";